<template>
  <Slideover :visible="visible">
    <form v-on:submit.prevent="searchCustomers">
      <header class="px-2 py-3 sm:px-6 bg-green-600 text-white">
        <div class="flex items-start justify-between space-x-3">
          <h2 class="text-lg leading-7 font-medium">
            {{ title }}
          </h2>
          <div class="h-7 flex items-center">
            <button
              type="button"
              aria-label="Close panel"
              @click="closeSlideover()"
              class="text-green-300 hover:text-white transition ease-in-out duration-150"
            >
              <icon set="solid" name="x" class="flex-shrink-0 m-1 h-5 w-5" />
            </button>
          </div>
        </div>
      </header>

      <!-- Main -->
      <div class="relative flex-1 py-3 px-2 mx-4">
        <div class="mt-6 grid grid-cols-1 gap-y-2 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-3">
            <label
              for="CustomerID"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Customer ID
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="CustomerID"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="form.CustomerID"
              />
            </div>
          </div>

          <div class="sm:col-span-3">
            <label
              for="FullName"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Name
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="FullName"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="form.FullName"
              />
            </div>
          </div>

          <div class="sm:col-span-3">
            <label
              for="Email"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Email
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="Email"
                type="email"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="form.Email"
              />
            </div>
          </div>

          <div class="sm:col-span-3">
            <label
              for="PhoneIndex"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Phone
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="PhoneIndex"
                type="phone"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="form.PhoneIndex"
              />
            </div>
          </div>

          <div class="sm:col-span-6">
            <label
              for="Address"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Address
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="Address"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="form.Address"
              />
            </div>
          </div>

          <div class="sm:col-span-2">
            <label
              for="City"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              City
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="City"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="form.City"
              />
            </div>
          </div>

          <div class="sm:col-span-2">
            <label
              for="State"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              State
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="State"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="form.State"
              />
            </div>
          </div>

          <div class="sm:col-span-2">
            <label
              for="Zip"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              ZIP / Postal
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="Zip"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                v-model="form.Zip"
              />
            </div>
          </div>
        </div>
      </div>
      <HttpError :error="error" />
      <!-- Footer -->
      <div class="flex-shrink-0 px-4 py-4 space-x-4 flex justify-end">
        <span class="inline-flex rounded-md shadow-sm">
          <button
            type="button"
            @click="closeSlideover()"
            class="py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
          >
            Cancel
          </button>
        </span>
        <span class="inline-flex rounded-md shadow-sm">
          <button
            :disabled="searching"
            type="submit"
            class="inline-flex justify-center items-center space-x-2 py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green active:bg-green-700 transition duration-150 ease-in-out"
          >
            <span>Search</span>
            <LoadingSpinner v-if="searching" class="text-white" />
          </button>
        </span>
      </div>
    </form>
    <div class="m-2">
      <CustomersGrid height="400" />
    </div>
  </Slideover>
</template>
<script>
import Slideover from "@/components/layout/Slideover.vue";
import CustomersGrid from "@/components/agGrid/CustomersGrid.vue";

export default {
  name: "CustomerSearch",
  data() {
    return {
      searching: false,
      customerClone: {},
      form: {
        CustomerID: null,
        FullName: null,
        Email: null,
        PhoneIndex: null,
        Address: null,
        City: null,
        State: null,
        Zip: null,
      },
      error: null,
    };
  },
  props: {
    title: {
      type: String,
      default: "Title",
    },
    footer: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  components: {
    Slideover,
    CustomersGrid,
  },
  computed: {
    customer() {
      return this.$store.getters["customers/getCustomer"];
    },
  },
  methods: {
    searchCustomers() {
      this.searching = true;
      this.form.newSearch = true;
      this.form.sort = "-CustomerID";
      this.error = null;
      this.$store
        .dispatch("customers/fetchCustomers", this.form)
        .catch((e) => (this.error = e))
        .finally(() => {
          this.searching = false;
        });
    },
    closeSlideover() {
      this.$emit("toggle-slideover", "customerSearch");
      Object.keys(this.form).forEach((key) => (this.form[key] = null));
    },
  },
  mounted() {
    // (dirty deep clone)
    this.customerClone = JSON.parse(JSON.stringify(this.customer));
  },
  filters: {},
};
</script>
